import { CartItem } from '../types';

class Storage {
  private CART_KEY: string = 'cart';

  getStoredCart(): CartItem[] {
    const cart = localStorage.getItem(this.CART_KEY);
    if (cart !== null) {
      return JSON.parse(cart);
    }
    return [];
  }

  storeCart(cart: CartItem[]) {
    localStorage.setItem(this.CART_KEY, JSON.stringify(cart));
  }
}

export default new Storage();
